import { BaseService } from '../base';
import type { Coverage, GlobalCoveragesResponse } from './types';

export class CoveragesService extends BaseService {
  private customBaseUrl = import.meta.env.VITE_API_URL;

  constructor() {
    super();
  }

  async getCoverages(
    productCode: string,
    versionDate: string
  ): Promise<{
    success: boolean;
    data?: Coverage[];
    error?: string;
  }> {
    try {
      const path = `/portal/v1/products/${productCode}/coverages?versionDate=${encodeURIComponent(
        versionDate
      )}`;
      const response = await this.get(path, {}, this.customBaseUrl);
      return this.handleJsonResponse<Coverage[]>(response);
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error
            ? error.message
            : 'Erro ao carregar coberturas',
      };
    }
  }

  async getGlobalCoverages(versionDate: string): Promise<{
    success: boolean;
    data?: GlobalCoveragesResponse;
    error?: string;
  }> {
    try {
      const path = `/portal/v1/products/global/coverages?versionDate=${encodeURIComponent(versionDate)}&withCodeDesc=Y`;
      const response = await this.get(path, {}, this.customBaseUrl);
      return this.handleJsonResponse<GlobalCoveragesResponse>(response);
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error
            ? error.message
            : 'Erro ao carregar catálogo de coberturas',
      };
    }
  }
}

export const coveragesService = new CoveragesService();
